import React from 'react';
import PropTypes from 'prop-types';

const ChevronRight = ({color = 'currentColor', ...props}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 7 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.33333 0.833496L5.5 5.00016L1.33333 9.16683"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

ChevronRight.propTypes = {
  color: PropTypes.string,
};

export default ChevronRight;
